import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, ChevronRight, Calculator, TrendingUp, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BusinessesOverviewHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const trustBadges = [{
    icon: Calculator,
    text: "Real-Time Data"
  }, {
    icon: TrendingUp,
    text: "ROI Focused"
  }, {
    icon: ShieldCheck,
    text: "Local Expertise"
  }];
  return;
}